import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { documentsSectionFromResponse } from '../../documents/recordDocumentsSection';
import { registryHref } from '../../registryHref';
import { formatQuals, NOT_STATED } from './model';
export function anchorRail(d, docs, docsState) {
    const { anchor, mappingCounts: m } = d;
    const typical = anchor ? formatQuals(anchor.typicalEducation, anchor.typicalMinExperienceYears) : null;
    const years = anchor?.typicalMinExperienceYears ?? -1;
    return [
        {
            id: 'usage',
            title: "Where it's used now",
            rows: d.usage.map((u, i)=>({
                    id: `${u.kind}-${u.context?.id ?? i}`,
                    label: /*#__PURE__*/ _jsx("span", {
                        "data-testid": Testids.registryLcatAnchor.usageRow,
                        children: u.context && registryHref(u.context) ? /*#__PURE__*/ _jsx(SpecraLink, {
                            href: registryHref(u.context) ?? undefined,
                            renderLink: renderRouterLink,
                            children: u.context.name
                        }) : u.context?.name ?? u.kind
                    }),
                    value: u.metricText
                })),
            children: d.usage.length === 0 ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "Not used in a pursuit, program or solicitation yet."
            }) : undefined
        },
        {
            id: 'anchor',
            title: 'Anchor',
            facts: [
                {
                    id: 'soc',
                    label: 'SOC',
                    value: anchor?.socCode || NOT_STATED
                },
                {
                    id: 'onet',
                    label: 'O*NET title',
                    value: anchor?.onetTitle || NOT_STATED
                },
                {
                    id: 'typical',
                    label: 'Typical',
                    value: typical && years >= 0 ? `${anchor?.typicalEducation ? `${anchor.typicalEducation} + ` : ''}${years} years` : typical ?? NOT_STATED
                }
            ],
            children: /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "Global reference data, the same for every tenant. Mappings to it are yours."
            })
        },
        {
            id: 'mappings',
            title: 'Mappings',
            facts: [
                {
                    id: 'approved',
                    label: 'Approved',
                    value: m?.approved ?? 0
                },
                {
                    id: 'waiting',
                    label: 'Waiting for review',
                    value: (m?.waiting ?? 0) > 0 ? /*#__PURE__*/ _jsx("span", {
                        "data-testid": Testids.registryLcatAnchor.mappingsWaiting,
                        children: /*#__PURE__*/ _jsxs(SpecraLink, {
                            href: `/registries/review-queue?group=mappings&anchor=${encodeURIComponent(anchor?.anchorId ?? '')}`,
                            renderLink: renderRouterLink,
                            children: [
                                m?.waiting,
                                " →"
                            ]
                        })
                    }) : /*#__PURE__*/ _jsx("span", {
                        "data-testid": Testids.registryLcatAnchor.mappingsWaiting,
                        children: "0"
                    })
                },
                {
                    id: 'mismatch',
                    label: 'Vehicle mismatch flags',
                    value: /*#__PURE__*/ _jsx(SpecraBadge, {
                        variant: "warning",
                        children: m?.vehicleMismatch ?? 0
                    })
                }
            ]
        },
        {
            id: 'related',
            title: 'Related categories',
            rows: d.related.map((r)=>({
                    id: r.anchorId,
                    label: /*#__PURE__*/ _jsx(SpecraLink, {
                        href: registryHref({
                            kind: 'LCAT_ANCHOR',
                            id: r.anchorId
                        }) ?? undefined,
                        renderLink: renderRouterLink,
                        children: r.title
                    }),
                    value: r.relation.toLowerCase()
                })),
            children: d.related.length === 0 ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "No related categories yet."
            }) : undefined
        },
        documentsSectionFromResponse({
            kind: 'LCAT_ANCHOR',
            id: anchor?.anchorId ?? ''
        }, docs, docsState)
    ];
}
